/** @jsxRuntime classic */
/** @jsx jsx */
import PropTypes from "prop-types";
import { jsx } from '@emotion/core';
const Points = ({
  data,
  getX,
  getY,
  maxY,
  minX,
  minY,
  pointsColor,
  pointsIsHoverOnZone,
  onHover,
  pointsRadius,
  pointsStrokeColor,
  pointsStrokeWidth,
  pointsVisible,
  unitWidth
}) => {
  return pointsVisible ? jsx("g", {
    className: 'DGN-Point-BarChart'
  }, data.map((point, i) => {
    return jsx("circle", {
      key: i,
      r: point.active ? pointsRadius * 1.2 : pointsRadius,
      cx: getX(point.x + unitWidth / 2),
      cy: getY(point.quantity),
      onMouseEnter: e => onHover(point, e),
      onMouseLeave: () => onHover(null, null),
      fill: pointsColor,
      stroke: pointsStrokeColor,
      strokeWidth: pointsStrokeWidth
    });
  }), pointsIsHoverOnZone && data.map((point, i) => {
    return jsx("rect", {
      key: i,
      x: getX(point.x > minX ? (data[i].x + data[i - 1].x) / 2 : minX),
      y: getY(maxY),
      fill: 'transparent',
      width: getX(1),
      height: getY(minY),
      onMouseEnter: e => onHover(point, e),
      onMouseLeave: () => onHover(null, null)
    }, jsx("title", null, point.name, " : ", point.quantity));
  })) : null;
};
Points.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    x: PropTypes.number,
    quantity: PropTypes.number
  })).isRequired,
  /** the getX position x on Ox*/
  getX: PropTypes.func,
  /** the getY position y on Oy */
  getY: PropTypes.func,
  /** the maxX is maximum of Ox quantity returned by data*/
  maxX: PropTypes.number,
  /** the maxY is maximum of Oy quantity returned by data*/
  maxY: PropTypes.number,
  /** the minX is minimum of OX quantity returned by data*/
  minX: PropTypes.number,
  /** the minY is minimum of Oy quantity returned by data*/
  minY: PropTypes.number,
  /** change the inner color of the point button  */
  pointsColor: PropTypes.string,
  /** show data information when hovering in the area containing the column */
  pointsIsHoverOnZone: PropTypes.bool,
  /** function change event hover */
  onHover: PropTypes.func,
  /** change the radius of the point is created */
  pointsRadius: PropTypes.number,
  /** change the border color of the point button  */
  pointsStrokeColor: PropTypes.string,
  /** the thickness of the inner core point */
  pointsStrokeWidth: PropTypes.number,
  /** show or hiden point */
  pointsVisible: PropTypes.bool,
  /** the unitWidth */
  unitWidth: PropTypes.number
};
Points.defaultProps = {
  getX: x => x,
  getY: quantity => quantity,
  pointsColor: '#fff',
  pointsIsHoverOnZone: false,
  onHover: () => {},
  pointsRadius: 3,
  pointsStrokeColor: '#111d5e',
  pointsStrokeWidth: 1,
  pointsVisible: false,
  unitWidth: 1
};
export default Points;